<template>
  <div>
    <apexchart
      v-if="sortedEntries.length"
      type="bar"
      :height="Math.max(300, sortedEntries.length * 44 + 80)"
      :options="opts"
      :series="series"
    />
    <empty-state
      v-else
      icon="mdi-food"
      :title="$t('no_data')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";
import { SHIFT_COLORS, CHART_FONT, GRID_COLOR } from "@/components/statistics-report/statsTheme";

export default {
  name: "MoreRestaurantsMealsChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    agg() {
      const map = {};
      for (const company of this.orders) {
        for (const meal of company.meals || []) {
          const name = this.toLatin(meal.name);
          if (!map[name]) map[name] = [0, 0, 0, 0];
          map[name][0] += meal.shift_one?.orders || 0;
          map[name][1] += meal.shift_two?.orders || 0;
          map[name][2] += meal.shift_three?.orders || 0;
          map[name][3] += meal.shift_four?.orders || 0;
        }
      }
      return map;
    },
    sortedEntries() {
      return Object.entries(this.agg)
        .map(([name, shifts]) => ({
          name,
          shifts,
          total: shifts.reduce((a, b) => a + b, 0),
        }))
        .filter((e) => e.total > 0)
        .sort((a, b) => b.total - a.total);
    },
    categories() {
      return this.sortedEntries.map((e) => e.name);
    },
    series() {
      return this.shiftLabels.map((label, i) => ({
        name: label,
        data: this.sortedEntries.map((e) => e.shifts[i]),
      }));
    },
    opts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          fontFamily: CHART_FONT,
        },
        plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: "65%" } },
        colors: SHIFT_COLORS,
        xaxis: { categories: this.categories, labels: { style: { fontSize: "12px" } } },
        yaxis: { labels: { style: { fontSize: "12px" }, maxWidth: 220 } },
        legend: { position: "bottom", horizontalAlign: "center" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: GRID_COLOR },
        responsive: [
          {
            breakpoint: 600,
            options: {
              yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 130 } },
              xaxis: { labels: { style: { fontSize: "11px" } } },
              legend: { fontSize: "12px", itemMargin: { horizontal: 6 } },
              plotOptions: { bar: { barHeight: "55%" } },
            },
          },
        ],
      };
    },
  },
};
</script>
